export const PARENT_PRODUCTS = {
	CONFLUENCE: 'confluence',
	JIRA: 'jira',
} as const;
